import React, { useState } from 'react';
import { DataGrid, GridColDef, GridPaginationModel } from '@mui/x-data-grid';
import { useGetProductManagementListQuery } from '../../redux/api/productApi';
import { ListManagementProduct, MediaContent } from '../../models/ManagementProduct';
import { IconButton, Stack, Tooltip } from '@mui/material';
import { Inventory } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../../helpers/formattingHelpers';

export default function ProductManagementTable() {
  const navigate = useNavigate();
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    page: 0,
    pageSize: 10,
  });
  const [sortModel, setSortModel] = useState<any>([{ field: '_id', sort: 'asc' }]);
  const { data, isFetching } = useGetProductManagementListQuery({
    page: paginationModel.page,
    pageSize: paginationModel.pageSize,
    sortField: sortModel[0]?.field,
    sortDirection: sortModel[0]?.sort,
    filters: {},
  });

  const onEditAetherInventory = (id: string) => () => {
    navigate(`/product-management/${id}/aether-inventory`);
  };

  const columns: GridColDef<ListManagementProduct>[] = [
    {
      field: '_id',
    },
    {
      field: 'MediaContent',
      headerName: 'Image',
      headerAlign: 'center',
      align: 'center',
      sortable: false,
      valueGetter: (value: MediaContent[]) => getImageUrl(value),
      renderCell: ({ value }) => {
        if (value) {
          return <img src={value} alt="Product" style={{ maxWidth: 50, maxHeight: 50 }} />;
        } else {
          return <></>;
        }
      },
    },
    {
      field: 'productId',
      headerName: 'Item No.',
      flex: 1,
    },
    {
      field: 'productName',
      headerName: 'Product Name',
      flex: 2,
    },
    {
      field: 'inhouseId',
      headerName: 'In House ID',
      flex: 2,
    },
    {
      field: 'vendorName',
      headerName: 'Vendor Name',
      flex: 2,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      sortable: false,
      flex: 1,
      renderCell: ({ row }: { row: ListManagementProduct }) => (
        <Stack direction={'row'} alignItems={'center'} height={'100%'}>
          <Tooltip title="Edit Aether Inventory">
            <IconButton onClick={onEditAetherInventory(row._id)}>
              <Inventory />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];

  return (
    <DataGrid
      autoHeight
      initialState={{
        columns: {
          columnVisibilityModel: { _id: false },
        },
      }}
      columns={columns}
      rows={data?.data || []}
      getRowId={(row) => row._id}
      paginationModel={paginationModel}
      onPaginationModelChange={setPaginationModel}
      sortModel={sortModel}
      onSortModelChange={setSortModel}
      disableRowSelectionOnClick
      rowCount={data?.total ?? -1}
      paginationMode="server"
      loading={isFetching}
      disableColumnFilter
    />
  );
}
